<template>
  <div class="home-page">
    <HeaderBar
      :currentDay="currentDay"
      :isLogin="isLogin"
      :user="user"
      @changeDay="handleChangeDay"
      @showLogin="showLoginDialog = true"
      @showAddTask="showAddTaskDialog = true"
      @showUserProfile="showUserProfileDrawer = true"
    />
    <main class="main-content">
      <div class="day-tabs">
        <el-button
          v-for="d in dayCount"
          :key="d"
          :type="currentDay == d ? 'primary' : 'default'"
          :class="{ 'current-part': isCurrentPartDay(d) }"
          @click="handleChangeDay(d)"
        >day {{ d }}</el-button>
      </div>
      <!-- 移除 TaskList 组件，它不再负责渲染 TaskCard -->
      <!-- <TaskList 
        :day="currentDay" 
        :user="user" 
        :tasks="tasks" 
        @refreshTasks="fetchTasks(currentDay)"
      /> -->

      <!-- 直接在 HomePage 中循环渲染 TaskCard -->
      <TaskListTitle :day="currentDay" :tasks="tasks" />
      <div v-if="tasks && tasks.length > 0">
          <TaskCard 
              v-for="task in tasks" 
              :key="task.taskId"
              :task="task"
              :user="user"
              @refresh="fetchTasks(currentDay)" 
              @requestLogin="showLoginDialog = true" 
          />
      </div>
       <el-empty v-else description="暂无任务" />

    </main>

    <el-dialog title="登录" v-model="showLoginDialog" width="30%" :fullscreen="isMobile">
      <LoginDialog @close="handleLoginSuccess" />
    </el-dialog>

    <el-dialog title="添加任务" v-model="showAddTaskDialog" width="50%" :fullscreen="isMobile">
       <AddTaskDialog @close="handleAddTaskSuccess" />
    </el-dialog>

    <UserProfileDrawer
      v-model="showUserProfileDrawer"
      @showLogin="showLoginDialog = true"
    />

  </div>
</template>

<script>
import { ref, computed, onMounted, watch, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import HeaderBar from '../components/HeaderBar.vue';
// import TaskList from '../components/TaskList.vue'; // 移除 TaskList 导入
import TaskListTitle from '../components/TaskList.vue'; // 重命名导入以便区分
import LoginDialog from '../components/LoginDialog.vue';
import AddTaskDialog from '../components/AddTaskDialog.vue';
import TaskCard from '../components/TaskCard.vue'; // 导入 TaskCard
import UserProfileDrawer from '../components/UserProfileDrawer.vue'; // 导入 UserProfileDrawer
import taskApi from '../api/task';

export default {
  components: {
    HeaderBar,
    TaskListTitle, // 使用重命名后的组件
    LoginDialog,
    AddTaskDialog,
    TaskCard, // 注册 TaskCard
    UserProfileDrawer, // 注册 UserProfileDrawer
  },
  setup() {
    const store = useStore();
    const currentDay = ref(1);
    const showLoginDialog = ref(false);
    const showAddTaskDialog = ref(false);
    const showUserProfileDrawer = ref(false); // 添加控制 UserProfileDrawer 显示的 ref
    const tasks = ref([]);
    const isMobile = ref(false); // 添加 isMobile ref
    const dayCount = ref(4); // 默认值
    const currentPart = ref(null); // 添加当前正在进行的部分

    const isLogin = computed(() => store.getters.isLogin);
    const user = computed(() => store.getters.user);

    // 计算属性：判断某个day是否是正在进行的部分
    const isCurrentPartDay = (d) => {
      if (!currentPart.value) return false;
      const partDay = parseInt(currentPart.value.replace('day', ''));
      return d === partDay;
    };

    // 检查是否为移动端
    const checkIsMobile = () => {
      isMobile.value = window.innerWidth < 768;
    };

    onMounted(() => {
      checkIsMobile();
      window.addEventListener('resize', checkIsMobile); // 监听窗口大小变化
      fetchTasks(currentDay.value);
      fetchSettings(); // 添加调用 fetchSettings 方法

      // 从 localStorage 获取 daycount
      const storedDayCount = localStorage.getItem('daycount');
      if (storedDayCount) {
        try {
          dayCount.value = parseInt(storedDayCount);
        } catch (e) {
          console.error('解析 daycount 失败:', e);
          dayCount.value = 4; // 解析失败时使用默认值
        }
      }

      // 从 localStorage 获取 currentpart
      const storedCurrentPart = localStorage.getItem('currentpart');
      if (storedCurrentPart) {
        currentPart.value = storedCurrentPart;
      }
    });

    onUnmounted(() => {
      window.removeEventListener('resize', checkIsMobile); // 移除监听器
    });

    const fetchTasks = async (day) => {
      try {
        const part = `day${day.toString().padStart(2, '0')}`;
        const response = await taskApi.getListByPartId(part);
        if (response.code === '000000') {
          tasks.value = response.data;
        } else {
          console.error('获取任务列表失败:', response.msg);
          tasks.value = [];
        }
      } catch (error) {
        console.error('获取任务列表异常:', error);
        tasks.value = [];
      }
    };

    const fetchSettings = async () => {
      try {
        const response = await taskApi.getSettings();
        if (response.code === '000000') {
          const settings = response.data;
          // 将部分数据保存到 localStorage
          localStorage.setItem('daycount', settings.daycount);
          localStorage.setItem('school', settings.school);
          localStorage.setItem('subject', settings.subject);
          localStorage.setItem('course', settings.course);
          localStorage.setItem('register', settings.register);
          localStorage.setItem('currentpart', settings.currentpart); // 保存当前正在进行的部分
    
          // 更新 dayCount ref
          dayCount.value = settings.daycount;
          // 更新 currentPart ref
          currentPart.value = settings.currentpart;
        } else {
          console.error('获取设置失败:', response.msg);
        }
      } catch (error) {
        console.error('获取设置异常:', error);
      }
    };

    const handleChangeDay = (day) => {
      currentDay.value = day;
      fetchTasks(day);
    };

    const handleLoginSuccess = () => {
      showLoginDialog.value = false;
      fetchTasks(currentDay.value);
    };

     const handleAddTaskSuccess = () => {
        showAddTaskDialog.value = false;
        fetchTasks(currentDay.value);
     };

    // 监听 isLogin 变化，如果用户退出登录，刷新任务列表
    watch(isLogin, (newIsLogin, oldIsLogin) => {
      if (oldIsLogin === true && newIsLogin === false) {
        // 用户退出登录
        fetchTasks(currentDay.value);
      }
    });

    return {
      currentDay,
      showLoginDialog,
      showAddTaskDialog,
      showUserProfileDrawer, // 导出 showUserProfileDrawer
      isLogin,
      user,
      tasks,
      isMobile, // 导出 isMobile
      dayCount, // 导出 dayCount
      isCurrentPartDay,
      handleChangeDay,
      handleLoginSuccess,
      handleAddTaskSuccess,
      fetchTasks
    };
  },
};
</script>

<style scoped>
.home-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex-grow: 1;
  padding: 20px;
  max-width: 1200px; /* 限制最大宽度 */
  margin: 0 auto; /* 居中 */
  width: 95%; /* 响应式宽度 */
}

.day-tabs {
  margin-bottom: 20px;
  display: flex; /* 使用 flex 布局 */
  flex-wrap: wrap; /* 允许换行 */
  gap: 10px; /* 使用 gap 设置间距 */
}

.day-tabs .el-button {
    /* margin-right: 10px; 移除右边距，使用 gap */
}

/* 当前正在进行的部分的样式 */
.day-tabs .el-button.current-part {
  border: 3px solid #67c23a !important;
  box-shadow: 0 0 8px rgba(103, 194, 58, 0.3);
  position: relative;
}

.day-tabs .el-button.current-part::after {
  content: '进行中';
  position: absolute;
  top: -8px;
  right: -8px;
  background: #67c23a;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  line-height: 1;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .main-content {
    padding: 10px; /* 减小内边距 */
    width: 98%; /* 调整宽度 */
  }

  .day-tabs {
    margin-bottom: 15px; /* 减小底部外边距 */
    justify-content: center; /* 按钮居中 */
  }

  .day-tabs .el-button {
    flex: 1; /* 按钮占据剩余空间 */
    min-width: calc(20% - 10px); /* 最小宽度，考虑 gap */
    max-width: calc(20% - 10px); /* 最大宽度，考虑 gap */
    margin: 0; /* 移除默认外边距 */
  }

  /* 确保 el-dialog 在移动端下全屏 */
  :deep(.el-dialog) {
    width: 100% !important;
    margin: 0 !important;
    max-width: 100%;
    max-height: 100%;
  }

  :deep(.el-dialog__body) {
    padding: 10px; /* 调整内边距 */
  }
}

</style> 